import { TRouteConfig, TRouteQuery } from "./routes.types";

export const createUrl = <TQuery extends TRouteQuery>(
  pathname: string,
  config?: TRouteConfig<TQuery>,
): string => {
  const path = pathname.replace(/\{([^{}]+)\}/g, (placeholder, key: string) => {
    const value = config?.pathParams?.[key];

    return value === undefined
      ? placeholder
      : encodeURIComponent(value);
  });

  const searchParams = new URLSearchParams();

  for (const [ key, value ] of Object.entries(config?.query ?? {})) {
    if (value !== undefined && value !== null) {
      searchParams.set(key, value);
    }
  }

  const query = searchParams.size > 0
    ? `?${searchParams.toString()}`
    : "";

  const hash = config?.hash
    ? `#${config.hash.replace(/^#/, "")}`
    : "";

  return `${path}${query}${hash}`;
};
